import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { Policy } from "types/generated";

import { POLICIES_COLUMN_ID } from "../constants";
import PoliciesTableCreatedAtCell from "./CreatedAtCell";
import PoliciesTableDescriptionCell from "./DescriptionCell";
import PoliciesTableDropdownCell from "./DropdownCell";
import PoliciesTableLabelsCell from "./LabelsCell";
import PoliciesTableNameCell from "./NameCell";
import PoliciesTableSpaceCell from "./SpaceCell";
import PoliciesTableTypeCell from "./TypeCell";
import PoliciesTableUpdatedAtCell from "./UpdatedAtCell";

export const POLICIES_TABLE_CELLS: TableCellPerColumn<Policy> = {
  [POLICIES_COLUMN_ID.NAME]: PoliciesTableNameCell,
  [POLICIES_COLUMN_ID.DESCRIPTION]: PoliciesTableDescriptionCell,
  [POLICIES_COLUMN_ID.LABELS]: PoliciesTableLabelsCell,
  [POLICIES_COLUMN_ID.TYPE]: PoliciesTableTypeCell,
  [POLICIES_COLUMN_ID.SPACE]: PoliciesTableSpaceCell,
  [POLICIES_COLUMN_ID.CREATED_AT]: PoliciesTableCreatedAtCell,
  [POLICIES_COLUMN_ID.UPDATED_AT]: PoliciesTableUpdatedAtCell,
  [POLICIES_COLUMN_ID.DROPDOWN]: PoliciesTableDropdownCell,
};
